<script lang="ts">
  type Variant = 'primary' | 'secondary' | 'tertiary' | 'navigation' | 'solo'
  type Size = 'small' | 'medium'

  export let label: string
  export let onClick: () => void = () => {}

  export let size: Size = 'medium'
  export let variant: Variant = 'primary'

  export let href: string | undefined = undefined
  export let fixedTo: string | undefined = undefined

  export let disabled = false
  export let isSubmitBtn = false

  let className = ''
  export { className as class }

  const clickHandler = () => {
    if (!disabled) {
      return onClick()
    }
  }

  // Used for control DOM element from outside
  export let forwardRef: HTMLButtonElement | undefined = undefined
  export let forwardAction: any = () => {}

  export function getRef() {
    return forwardRef
  }

  $: variantClass = `btn--${variant}`
  $: sizeClass = `btn--${size}`
  $: disabledClass = disabled ? 'btn__disabled' : ''
  $: btnType = isSubmitBtn ? 'submit' : 'button'

  $: btnClass = ['btn', variantClass, sizeClass, className, disabledClass].join(' ')
</script>

<template lang="pug">
  include ./template.pug
</template>

<style lang="sass" src="./style.sass">

</style>
